import { RouteComponentProps, useLocation } from '@gatsbyjs/reach-router';
import React, { useEffect, useState } from 'react'
import { APCenter, APJourneyApp, APJourneyWeb, APSizedBox, APTag, getIt, JourneySection, JourneyStep } from 'ap-components';
import { CircularProgress } from '@mui/material';
import SharedPrefs from '../../Services/SharedPrefs';
import { launchPage } from '../../Common/Utils';
import EmpanelmentService from '../../Services/EmpanelmentService';
import VerifyDetails from './VerifyDetails';
import PersonalDetailsPage from './PersonalDetailsPage';
import BankDetails from './BankDetailsPage';

export interface EmpanelmentData {
    arn: string,
    //arnType:String,
    email: string,
    password: string,
    name: string,
    phone: string,
    dob: string,
    pan: string,
    isEmailVerified: boolean,
    isPhoneVerified: boolean,
    euin: string,
    euinPath: string,
    workFlowProgress: string,
}


export const ExpressEmpanelment = (props: RouteComponentProps) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    var token = searchParams.get('po_token') ?? getIt(SharedPrefs).getItem('poToken');;
    const [form, setForm] = useState<Partial<EmpanelmentData>>();
    const [isLoading, setIsLoading] = useState(false)

    const rawData = searchParams.get("data");
    let data: any = null;

    if (rawData) {
        data = JSON.parse(decodeURIComponent(rawData));
    }

    async function getData(token?: string | null) {
        try {
            setIsLoading(true);
            if (token) {
                getIt(SharedPrefs).setItem('poToken', token);
                const response = await getIt(EmpanelmentService).getEmpanelmentData();
                setForm(response);
                if (!response.workFlowProgress) {
                    launchPage('/signup/verification');
                }
                setIsLoading(false);
            } else {
                if (!form) {
                    setForm(data.empanelmentData);
                }

                if (data.logId) {
                    const response = await getIt(EmpanelmentService).getLogData({ logId: data.logId });
                    setForm({ ...data.empanelmentData, isEmailVerified: response.isEmailVerified, isPhoneVerified: response.isMobileVerified })
                }
                setIsLoading(false);
            }
        } catch (err: any) {
            setForm(data.empanelmentData);
            const metaData = err?.response?.data.metaData;
            if (!!metaData) {
                if (metaData.invalidLogin) {
                    launchPage('/signup/verification');
                }
            }
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getData(token);
    }, []);

    if (isLoading || !form) {
        return <APCenter><CircularProgress /></APCenter>
    }

    return <EmpanelmentStepper empanelmentData={form} updateEmpanelmentData={setForm} locationStateData={data} />

}


function EmpanelmentStepper({ empanelmentData, updateEmpanelmentData, locationStateData }: { empanelmentData: Partial<EmpanelmentData>, updateEmpanelmentData: (data: Partial<EmpanelmentData>) => void, locationStateData: any }) {
    var steps: JourneyStep[] = []

    if (!!empanelmentData) {
        steps = [
            VerifyDetails({ empanelmentData: empanelmentData, updateEmpanelmentData: updateEmpanelmentData, maskedEmail: locationStateData?.maskedEmail ?? '', maskedPhone: locationStateData?.maskedPhone ?? '', logId: locationStateData?.logId ?? '' }),
            PersonalDetailsPage({ empanelmentData: empanelmentData, updateEmpanelmentData: updateEmpanelmentData }),
            BankDetails({ empanelmentData: empanelmentData, updateEmpanelmentData: updateEmpanelmentData })
        ]
    }

    return (
        <div style={{ height: '100vh', width: '100vw', margin: 0, padding: 0, position: 'fixed', top: 0, left: 0, zIndex: 0 }}>
            <APJourneyApp
                headerSpacing='spacious'
                style={{ height: '100%' }}
                mode='linear'
                title="Mutual Fund Activation"
                initialStepId={empanelmentData.workFlowProgress}
                description='Activate account to invest in Mutual Funds'
                steps={steps}
            />
        </div>
    )

}